// removed by extract-text-webpack-plugin
module.exports = {"initialUtilityBar":"initial-utility-bar--1F0lG","utilityBar":"utility-bar--2lPZs","btnWrapper":"btn-wrapper--3ChIk","btnBackWrapper":"btn-back-wrapper--2IuyG","btnTextWrapper":"btn-text-wrapper--2-zJK","btnBackTextWrapper":"btn-back-text-wrapper--2Ll-e","buttonGroup":"button-group--FwEtA","body":"body--2LY6I","helpText":"help-text--3_28C","select":"select--aLPB3","createCategoryWrapper":"create-category-wrapper--2CLgV"};


//////////////////
// WEBPACK FOOTER
// ./app/components/containers/ticketing/categorySettings/createCategory/createCategory.scss
// module id = W1zf
// module chunks = 1